import React from 'react';
import BusinessKeysForm from '../../../../forms/maintenance/BusinessKeysForm'

export default function BusinessKeys(props) {

    return (
        <>
            <div className="col-12">
                <BusinessKeysForm handledUpdateIva={props.handledUpdateIva} paramInfoIva={props.paramInfoIva} paramInfoData={props.paramInfoData} handledEdit={props.handledEdit} handledDelete={props.handledDelete} handledNew={props.handledNew}/>
            </div>
        </>
    )
}




